module.exports = __webpack_public_path__ + "img/twitter-active.0052c577.svg";